import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import FileSystem from "components/FileSystem";
import CartaContabilita from "components/CartaContabilita";
import CartaContabilitaAQ from "components/CartaContabilita/AQ.js";
import DettaglioCommessa from "../commessa/recapCommessa.js"
import DettaglioContabilita from "./dettaglio.js"

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import CircularProgress from '@mui/material/CircularProgress';

import * as ajax from "helpers/ajax";
import { valid } from "chroma-js";




export default class Contabilita extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            openCommessa: null,
            openIncarichi: null,
            openDetail:null,
            filter:["in corso"],
            search: "",
            loading:true,
        }
    }

    componentDidMount=()=>{
        this.load()
    }

    load=()=>{
        let statusFilter="";
        this.state.filter.map((el)=>{
            statusFilter+="&filters[stato][$in]="+el
        })

        let filterIncarichi = "&filters[commessa_madre]";
        if (this.props.commessaMadre) {
            filterIncarichi = "&filters[commessa_madre]=" + this.props.commessaMadre
        }

        ajax.ajaxGetStrapi("commessas?populate=gara&populate=fattures&populate=preventivis&populate=commessa_madre&populate=incarichi.*&populate=incarichi.fattures&populate=incarichi.commessa_madre&populate=commessa_checklists"+statusFilter+filterIncarichi, this.loadCallback)
    }

    loadCallback = (response) => {
        this.setState({ data: response.data, loading:false })
    }

    setFilter = (val) => {
        if (this.state.loading) { return }

        let temp = this.state.filter
        
        if (temp.includes(val)) {
            temp.splice(temp.indexOf(val), 1)
        } else {
          temp.push(val)
        }
      this.setState({filter:temp, data:[], loading:true},this.load())
    }

    render() {

        if (this.state.openCommessa) {
            return <DettaglioCommessa data={this.state.openCommessa} backFunction={() => this.setState({ openCommessa: null })} />
        }
        if (this.state.openIncarichi) {
            return <Contabilita title={this.state.openIncarichi.nome + " - Dettagli incarichi"} commessaMadre={this.state.openIncarichi.id} backFunction={() => this.setState({ openIncarichi: null })} />
        }
        if (this.state.openDetail) {
            return <DettaglioContabilita data={this.state.openDetail} backFunction={() => this.setState({ openDetail: null })} />
        }

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    backButton={this.props.commessaMadre ? this.props.backFunction : null}
                    text={this.props.title ? this.props.title : "Contabilità"}
                />


                <Grid container={true} style={{ justifyContent: "space-between" }}>
                    <Grid item>
                        <ToggleButtonGroup
                            value={this.state.filter}
                            onChange={(val) => this.setFilter(val.target.value)}
                        >
                            <ToggleButton value="finito" disabled={this.state.loading}>
                                Finito
      </ToggleButton>
                            <ToggleButton value="in corso" disabled={this.state.loading}>
                                In corso
      </ToggleButton>
                            <ToggleButton value="in allestimento" disabled={this.state.loading}>
                                In allestimento
      </ToggleButton>
                            <ToggleButton value="sospeso" disabled={this.state.loading}>
                                Sospeso
      </ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>

                    <MDInput
                        placeholder={"Cerca"}
                        value={this.state.search}
                        onChange={(e) => this.setState({ search: e.target.value })}
                    />
                </Grid>

                {this.state.loading ?
                    <div style={{ textAlign: "center", marginTop: 15 }}><CircularProgress /></div>
                    :
                    this.state.data.map((el, index) => {
                        if (el.nome.toLowerCase().includes(this.state.search.toLowerCase())) {
                            if (el.incarichi.length > 0) {
                                return <CartaContabilitaAQ data={el} index={index} openCommessa={() => { this.setState({ openCommessa: this.state.data[index] }) }} openIncarichi={() => { this.setState({ openIncarichi: this.state.data[index] }) }} openDetail={() => { this.setState({ openDetail: this.state.data[index] }) }} key={"contabilita-" + index} />
                            } else {
                                return <CartaContabilita data={el} index={index} openCommessa={() => { this.setState({ openCommessa: this.state.data[index] }) }} openDetail={() => { this.setState({ openDetail: this.state.data[index] }) }} key={"contabilita-" + index} />
                            }
                        }
                    })}

            </DashboardLayout>
        )
    }
}


